/**
 * Page Transitions
 * Fast, smooth SPA-like transitions with progressive rendering
 */

class PageTransition {
    constructor() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.container = document.getElementById('PageContainer');
        this.links = document.querySelectorAll('a[href^="/"]:not([target="_blank"]):not([href^="/cart"]):not([href^="/account"]):not([data-no-transition])');

        this.init();
    }

    init() {
        // Don't animate on initial page load - instant stable render

        // Bind links
        document.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            
            // Exclude Klaviyo popups and forms from page transitions
            const klaviyoContainer = e.target.closest('#klaviyo-forms-container, .klaviyo-form, .klaviyo-form-teaser, [class*="klaviyo"]');
            if (klaviyoContainer) {
                return; // Let Klaviyo handle its own clicks
            }

            // Check if valid internal link
            if (
                link &&
                link.href.startsWith(window.location.origin) &&
                !link.target &&
                !link.hasAttribute('data-no-transition') &&
                !link.href.includes('#') &&
                !link.href.includes('/cart') &&
                !e.ctrlKey && !e.metaKey
            ) {
                e.preventDefault();
                this.navigate(link.href);
            }
        });

        // Handle browser back/forward
        window.addEventListener('pageshow', (event) => {
            if (event.persisted && this.container) {
                this.container.classList.remove('is-exiting');
                this.container.classList.add('is-entering');
            }
        });
    }

    navigate(url) {
        if (!this.container || this.reducedMotion) {
            window.location = url;
            return;
        }

        // Add loading bar
        this.showLoader();

        // Animate out
        this.container.classList.remove('is-entering');
        this.container.classList.add('is-exiting');

        // Navigate immediately — the artificial delay bought nothing on a
        // server-rendered theme and taxed every internal click by 200ms.
        window.location = url;
    }

    showLoader() {
        let loader = document.querySelector('.transition-loader');
        if (!loader) {
            loader = document.createElement('div');
            loader.className = 'transition-loader';
            loader.innerHTML = '<div class="transition-loader__bar"></div>';
            document.body.appendChild(loader);
        }

        // Animate bar faster
        const bar = loader.querySelector('.transition-loader__bar');
        setTimeout(() => { bar.style.width = '40%'; }, 10);
        setTimeout(() => { bar.style.width = '80%'; }, 150);
    }
}

// Initialize
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new PageTransition();
    });
} else {
    new PageTransition();
}
